const { NIMBUS_DATA_TYPES } = require('../nimbus-data-types');

module.exports = {
  displayName: 'Transporter Based Vehicles',
  description: 'Select transporter before vehicle type',
  sortOrder: 1,
  name: 'tranasporterBasedVehicles',
  documentKey: 'transporter_based_vehicles',
  values: {
    transporter_based_vehicles: {
      dataType: NIMBUS_DATA_TYPES.BOOLEAN,
      defaultValue: false,
      displayName: 'Transporter Based Vehicles',
      documentKey: 'transporter_based_vehicles',
    },
  },
};
